import initPhotoswipe from '../../../javascripts/utils/photoswipe';

// lightbox
initPhotoswipe(Array.prototype.slice.call(document.querySelectorAll('.js-lightbox')));
